import { computed, inject, Injectable, signal } from '@angular/core';
import { ListingPageModelAbstract } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model-abstract';
import { ListingPageModel } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.types';
import { ListingTableComponent } from 'src/app/shared/components/listing-table/listing-table.component';
import { ListingPageId } from '@portal/shared/components/listing-page/store/listing-page-store.types';
import { ListingPageModelRegistry } from '@portal/shared/components/listing-page/services/listing-page-model/listing-page-model-registry.service';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { OrderDirection } from 'src/app/pages/equipment/devices/components/devices.models';
import { MissingProgrammingRecordsFieldName } from '../missing-programming-records.types';
import { MissingProgrammingRecordsListingFiltersSourceService } from './missing-programming-records-listing-filters-source.service';
import { MissingProgrammingRecordsListingDataSourceService } from './missing-programming-records-listing-data-source.service';
import { MissingProgrammingRecordsListingExportConfigService } from './missing-programming-records-listing-export-config.service';
import { createMissingProgrammingRecordsColumns } from './missing-programming-records-listing.columns';
import {
  MISSING_PROGRAMMING_RECORDS_DEFAULT_SEARCH_TYPE,
  MISSING_PROGRAMMING_RECORDS_SEARCH_TYPES
} from './missing-programming-records-listing.search';
import { MISSING_PROGRAMMING_RECORDS_SORT_FIELD } from './missing-programming-records-listing.sort';

@Injectable()
export class MissingProgrammingRecordsListingModelService extends ListingPageModelAbstract implements ListingPageModel {
  private readonly listingPageModelRegistry = inject(ListingPageModelRegistry);

  readonly pageTitle = TranslateRegistry.get.MAIN_MENU.TITLE.MISSING_PROGRAMMING_RECORDS;
  readonly searchTypeList = signal(MISSING_PROGRAMMING_RECORDS_SEARCH_TYPES);
  readonly selectedSearchType = signal(MISSING_PROGRAMMING_RECORDS_DEFAULT_SEARCH_TYPE);
  readonly sorting = signal({
    columnName: MissingProgrammingRecordsFieldName.LastTransmissionTime,
    orderDirection: OrderDirection.DESC
  });
  readonly tableColumns = computed(() => createMissingProgrammingRecordsColumns());
  readonly filterSource = inject(MissingProgrammingRecordsListingFiltersSourceService);
  readonly dataSource = inject(MissingProgrammingRecordsListingDataSourceService);
  readonly exportConfig = inject(MissingProgrammingRecordsListingExportConfigService);

  readonly sortField = MISSING_PROGRAMMING_RECORDS_SORT_FIELD;
  readonly tableCmp = ListingTableComponent;
  readonly exportButtonVisible = true;
  readonly columnsButtonVisible = false;
  readonly resetButtonVisible = false;

  get pageId(): ListingPageId {
    return ListingPageId.MissingProgrammingRecords;
  }

  constructor() {
    super();
    this.listingPageModelRegistry.add(ListingPageId.MissingProgrammingRecords, this);
  }
}
